export default "__VITE_ASSET__tx2R6Ph2__"